

export default {
  SET_METODE_LIST(state, payload){
    state.metodeList = payload
  },
  SET_JENIS_LIST(state, payload){
    state.jenisList = payload
  },
  SET_TUTOR_LIST(state, payload){
    state.tutorialList = payload
  },
  SET_TOTAL(state, payload){
    state.totalRecords = payload
  },
  SET_TOTAL_NON_LOGIN(state, payload){
    state.totalNonLogin = payload
  },
  SET_TOTAL_METODE(state, payload){
    state.totalMetode = payload
  },
  SET_TOTAL_JENIS(state, payload){
    state.totalJenis = payload
  },
  SET_TOTAL_TP(state, payload){
    state.totalTP = payload
  },
}
